module.exports = "<form [formGroup]=\"form\">\r\n  <input\r\n    type=\"text\"\r\n    [textMask]=\"{mask: mask_time}\"\r\n    [disabled]=\"disabled\"\r\n    name=\"time\"\r\n    formControlName=\"time\"\r\n    [required]=\"isRequired\"\r\n  >\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/input-time/components/input-time/input-time.component.html
// module id = 2617
// module chunks = 66